import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Centered, Label, Layout } from 'apps/auth/scripts/components';
import { EmailSvg } from 'apps/shared/scripts/assets';

import { descriptionClassName } from './styles';

const AlreadyVerified = () => {
  const navigate = useNavigate();

  const onSubmit = useCallback(async () => {
    navigate('/dashboard/settings');
  }, [navigate]);

  return (
    <Layout
      centered
      buttonLabel={'Return Home'}
      heading={'Already Verified'}
      icon={<EmailSvg />}
      subheader={
        <Centered>
          <Label
            value={
              <div className={descriptionClassName}>
                <span>Your email address has already been verified.</span>
                <span>No further action is needed.</span>
              </div>
            }
          />
        </Centered>
      }
      onSubmit={onSubmit}
    />
  );
};

AlreadyVerified.displayName = 'AlreadyVerified';

export default AlreadyVerified;
